const API_URL = process.env && process.env.REACT_APP_API_HOST;
const AUTHORITY_SERVER = process.env && process.env.REACT_APP_AUTHORITY_SERVER;

function apiRequest(path, data, method) {
  //console.log('API_URL!!!', API_URL);
  // console.log('AUTHORITY_SERVER!!!', AUTHORITY_SERVER);
  let AUTHORITY_SERVER = '';
  if (window.location.hostname.toLowerCase().includes('sabre'))
    AUTHORITY_SERVER = process.env.REACT_APP_SABRE_AUTHORITY_SERVER;
  else if (window.location.hostname.toLowerCase().includes('synxis'))
    AUTHORITY_SERVER = process.env.REACT_APP_SYNXIS_AUTHORITY_SERVER;
  else if (window.location.hostname.toLowerCase().includes('myma.ai'))
    AUTHORITY_SERVER = process.env.REACT_APP_MYMA_AUTHORITY_SERVER;
  else if (window.location.hostname.toLowerCase().startsWith('app.smartpabx.ai'))
    AUTHORITY_SERVER =  process.env.REACT_APP_SMARTPABX_AI_AUTHORITY_SERVER;    
  else AUTHORITY_SERVER = process.env.REACT_APP_AUTHORITY_SERVER;
  let access_token = JSON.parse(
    sessionStorage.getItem(
      `oidc.user:${AUTHORITY_SERVER}:${process.env.REACT_APP_IDENTITY_SERVER_CLIENT_APP_ID}`
    )
  ).access_token;
  //console.log('access_token!!!', access_token);
  return fetch(`${API_URL}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + access_token,
    },
    body: JSON.stringify(data),
  });
}

export const getRequest = (path, data) => apiRequest(path, data, 'GET');
export const postRequest = (path, data) => apiRequest(path, data, 'POST');
